import {inject, observer} from 'mobx-react';
import React, {useEffect, useState} from 'react';
import CourseAnalyticsOverviewUI from '../view/CourseAnalyticsOverviewUI';
import {useOutletContext, useParams} from 'react-router-dom';
import CourseAnalyticsOverviewStore from '../store/CourseAnalyticsOverviewStore';
import {downloadCSV} from '../../../../../utils/downloadCsv';
import {analyticsText} from '../../../analyticsText';
import {mapGradebook, MappedGradebook} from '../mappers';
import {hasValue} from '../../../../../utils/typecheck';
import {GRADE_SUCCESS} from '../../../components/GradesTable';

interface Props {
  courseAnalyticsOverviewStore?: CourseAnalyticsOverviewStore;
}

const CourseAnalyticsOverviewContainer = inject('courseAnalyticsOverviewStore')(
  observer(({courseAnalyticsOverviewStore}: Props) => {
    const [gradebook, setGradebook] = useState<MappedGradebook>();
    const {organizationId, courseId} = useParams();

    const [, courseName] = useOutletContext<[boolean, string, number]>();

    useEffect(() => {
      if (organizationId && courseId) {
        courseAnalyticsOverviewStore!
          .fetchCourseGradebook(organizationId, courseId)
          .then(res => {
            if (res) {
              setGradebook(mapGradebook(res));
            }
          });
      }
    }, [courseId]);

    const onExport = () => {
      if (!gradebook) return;
      downloadCSV(
        [
          [
            analyticsText.learner,
            analyticsText.avgScore,
            ...gradebook.headerItems.map(l => l.title),
          ],
          [
            analyticsText.overallScore,
            hasValue(gradebook.avgScores.overallAvgScore)
              ? gradebook.avgScores.overallAvgScore + '%'
              : '-',
            ...gradebook.headerItems.map(l =>
              hasValue(gradebook.avgScores.scores[l.id]?.grade)
                ? gradebook.avgScores.scores[l.id]?.grade + '%'
                : '-',
            ),
          ],
          ...gradebook.learnerRecords.map(learner => [
            learner.name,
            learner.avgGrade,
            ...gradebook.headerItems.map(lesson =>
              hasValue(learner.scores[lesson.id]?.grade)
                ? learner.scores[lesson.id].grade + '%'
                : learner.scores[lesson.id]?.status === GRADE_SUCCESS
                ? 'Completed'
                : '-',
            ),
          ]),
        ],
        courseName + '_overview' + '.csv',
      );
    };

    return (
      <CourseAnalyticsOverviewUI
        organizationId={organizationId || ''}
        courseId={courseId || ''}
        onExport={onExport}
        isLoading={courseAnalyticsOverviewStore!.isLoading}
        gradebook={gradebook}
      />
    );
  }),
);

export default CourseAnalyticsOverviewContainer;
